import { Routes } from '@shared/constants/routes';
import { useAppSelector } from '@shared/redux';
import { authSelectors } from '@shared/redux/ducks/auth';
import { Navigate, Outlet, useMatch } from 'react-router-dom';

export const PublicOutlet = () => {
  const isAuthorized = useAppSelector(authSelectors.selectIsAuthorized);
  const isInvitePage = !!useMatch('/invite/:token');

  const onSignIn = !!useMatch(Routes.authentication.signIn);
  const onOauthGoogle = !!useMatch(Routes.authentication.oauthGoogle);
  const onOauthYandex = !!useMatch(Routes.authentication.oauthYandex);

  const onAuthPages = onSignIn || onOauthGoogle || onOauthYandex;

  // if (isAuthorized) {
  //   return <Navigate to={Routes.analytics.root} replace />;
  // }

  if (isInvitePage) {
    const tokenFromPath = location.pathname.split('/invite/')[1];

    if (tokenFromPath) {
      localStorage.setItem('pendingInviteToken', tokenFromPath);
    }

    return isAuthorized ? <Outlet /> : <Navigate to={Routes.authentication.signIn} />;
  }

  return onAuthPages ? <Outlet /> : <Navigate to={Routes.authentication.signIn} replace />;
};
